import { styled } from '@mui/material';

import { ButtonBase } from '../ButtonBase';
import { iconButtonClasses } from './theme';

import type { IconButtonOwnerState, IconButtonProps } from './types';

export default function IconButton(props: IconButtonProps) {
  // useThemeProps 제거, theme defaultProps를 컴포넌트에서 직접 처리
  const {
    children,
    variant = 'accent', // theme defaultProps에서 이동
    size = 'xl', // theme defaultProps에서 이동
    disabled = false, // theme defaultProps에서 이동
    ...others
  } = props;

  const ownerState: IconButtonOwnerState = { ...props, variant, size, disabled };

  return (
    <IconButtonRoot
      appearance="solid"
      content="icon"
      variant={variant}
      size={size}
      disabled={disabled}
      ownerState={ownerState}
      {...others}
    >
      {children}
    </IconButtonRoot>
  );
}
IconButton.displayName = 'IconButton';

const IconButtonRoot = styled(ButtonBase, {
  target: iconButtonClasses.root,
})<{ ownerState: IconButtonOwnerState }>`
  /* theme.ts의 styleOverrides는 비어있었으므로 추가 스타일 없음 */
`;
